import dayjs from "dayjs";
import React, { useContext, useEffect, useState } from "react";
import GlobalContext from "../context/GlobalContext";
import { getMonth } from "../util";
import 'dayjs/locale/nl';

export default function SmallCalendar() {
  dayjs.locale("nl"); // Set the locale to Dutch
  
  const [currentMonthIdx, setCurrentMonthIdx] = useState(
    dayjs().month()
  );
  const [currentYear, setCurrentYear] = useState(
    dayjs().year()
  );
  const [currentMonth, setCurrentMonth] = useState(getMonth());
  
  useEffect(() => {
    setCurrentMonth(getMonth(currentMonthIdx, currentYear));
  }, [currentMonthIdx, currentYear]);

  const {
    monthIndex,
    setSmallCalendarMonth,
    setDaySelected,
    daySelected,
    setMonthIndex,
  } = useContext(GlobalContext);

  useEffect(() => {
    setCurrentMonthIdx(monthIndex);
    // Extract year from window.currentDate if available
    if (typeof window !== 'undefined' && window.currentDate && window.currentDate.year) {
      setCurrentYear(window.currentDate.year());
    }
  }, [monthIndex]);

  function handlePrevMonth() {
    let newMonth = currentMonthIdx;
    let newYear = currentYear;
    
    if (currentMonthIdx === 0) {
      newMonth = 11;
      newYear = currentYear - 1;
    } else {
      newMonth = currentMonthIdx - 1;
    }
    
    setCurrentMonthIdx(newMonth);
    setCurrentYear(newYear);
    
    // Don't update global state - only navigate the small calendar display
  }
  
  function handleNextMonth() {
    let newMonth = currentMonthIdx;
    let newYear = currentYear;
    
    if (currentMonthIdx === 11) {
      newMonth = 0;
      newYear = currentYear + 1;
    } else {
      newMonth = currentMonthIdx + 1;
    }
    
    setCurrentMonthIdx(newMonth);
    setCurrentYear(newYear);
    
    // Don't update global state - only navigate the small calendar display
  }
  function getDayClass(day) {
    const format = "DD-MM-YY";
    const nowDay = dayjs().format(format);
    const currDay = dayjs(day).format(format);
    const slcDay = daySelected && dayjs(daySelected).format(format);
    if (nowDay === currDay) {
      return "bg-blue-500 text-white hover:bg-blue-500";
    } else if (currDay === slcDay) {
      return "bg-blue-100 text-blue-600 font-bold";
    } else {
      return "hover:bg-gray-100 dark:hover:bg-gray-800";
    }
  }
  return (
    <div>
      <header className="flex justify-between items-center mb-1">
        <p className="text-sm font-medium text-gray-600 dark:text-gray-300">
          {dayjs(new Date(currentYear, currentMonthIdx)).format(
            "MMMM YYYY"
          )}
        </p>
        <div className="flex items-center">
          <button type="button" onClick={handlePrevMonth} className="btn-icon w-7 h-7" aria-label="Vorige maand">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18" height="18" fill="currentColor" aria-hidden="true">
              <path d="M15.41 7.41 14 6l-6 6 6 6 1.41-1.41L10.83 12z" />
            </svg>
          </button>
          <button type="button" onClick={handleNextMonth} className="btn-icon w-7 h-7" aria-label="Volgende maand">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18" height="18" fill="currentColor" aria-hidden="true">
              <path d="M10 6 8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" />
            </svg>
          </button>
        </div>
      </header>
      <div className="grid grid-cols-7 grid-rows-6">
        {currentMonth[0].map((day, i) => (
          <span key={i} className="text-[11px] py-1 text-center uppercase tracking-wide text-gray-400">
            {day.format("dd").charAt(0)}
          </span>
        ))}
        {currentMonth.map((row, i) => (
          <React.Fragment key={i}>
            {row.map((day, idx) => (
              <button
                key={idx}
                type="button"
                onClick={() => {
                  const dayDate = dayjs(day);
                  const newDate = dayDate.startOf('month');

                  if (typeof window !== 'undefined') window.currentDate = newDate;
                  if (typeof setMonthIndex === 'function') setMonthIndex(newDate.month());

                  setSmallCalendarMonth(newDate.month());
                  setDaySelected(day);
                }}
                className={`py-1 w-full rounded-full ${getDayClass(day)}`}
              >
                <span className="text-sm">{day.format("D")}</span>
              </button>
            ))}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
}
